// Fluxo das telas: entrar -> escolher personagem (ou criar) -> jogo.
import { render } from 'preact';
import { useState } from 'preact/hooks';
import type { CharacterSummary } from '../../shared/src/protocol';
import { api, session } from './api';
import { Login } from './screens/Login';
import { Characters } from './screens/Characters';
import { CreateCharacter } from './screens/CreateCharacter';
import { Game } from './screens/Game';

import { startUpdateWatch } from './update';
import { installNoPullRefresh } from './noPullRefresh';

type Screen = { name: 'login' } | { name: 'characters' } | { name: 'create' } | { name: 'game'; character: CharacterSummary };

function App() {
  // depois de uma atualização automática, volta direto para o personagem que estava jogando
  const resume = (() => { try { const c = sessionStorage.getItem('noxara.play'); return c && session.token ? (JSON.parse(c) as CharacterSummary) : null; } catch { return null; } })();
  const [screen, setScreenRaw] = useState<Screen>(resume ? { name: 'game', character: resume } : session.token ? { name: 'characters' } : { name: 'login' });
  const setScreen = (s: Screen) => {
    try { if (s.name === 'game') sessionStorage.setItem('noxara.play', JSON.stringify(s.character)); else sessionStorage.removeItem('noxara.play'); } catch { /* modo privado */ }
    setScreenRaw(s);
  };
  const expired = () => { session.clear(); setScreen({ name: 'login' }); };

  switch (screen.name) {
    case 'login':
      return <Login onDone={() => setScreen({ name: 'characters' })} />;
    case 'characters':
      return (
        <Characters
          onPlay={(c) => setScreen({ name: 'game', character: c })}
          onCreate={() => setScreen({ name: 'create' })}
          onLogout={() => { void api.logout().catch(() => {}); expired(); }}
          onExpired={expired}
        />
      );
    case 'create':
      return <CreateCharacter onDone={() => setScreen({ name: 'characters' })} onCancel={() => setScreen({ name: 'characters' })} />;
    case 'game':
      return <Game character={screen.character} onLeave={() => setScreen({ name: 'characters' })} onExpired={expired} />;
  }
}

render(<App />, document.getElementById('app')!);
startUpdateWatch();
installNoPullRefresh();
